module.exports = __webpack_public_path__ + "img/hide.c32f3175.svg";